import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const PeopleStepsWrapper = styled.div`
  width: calc(100% - var(--people-sidebar-width));

  display: flex;
  flex-direction: column;
  gap: 24px;

  padding-bottom: 40px;

  ${BREAKPOINTS.tablet} {
    width: 100%;
    padding: 10px 0px 40px 0px;
  }

  position: relative;
`;
